import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { BountyStatus, Card, CardBody, CardImg, CardText, CardTitle, TimeProgress } from '@kambria/kambria-lego';
import Utils from 'helpers/utils';
import in_progress_icon from 'static/svg/ic-closed.svg';
import moment from 'moment';
import {
  Box,
  CardHeader,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Container,
  Typography,
  Button,
  Tooltip,
} from '@mui/material';
import { Row, Col } from 'antd';
import { withRouter } from 'react-router-dom';
import '../../custom-home.scss';
import './packages-payment.scss';
import { I18n } from '../../../../../helpers/i18n';

class CardPackagePayment extends React.Component {
  state = {
    teams: null,
    prize: null,
  };

  async componentDidMount() {}

  formatPrice = (price) => {
    if (price === null || price === undefined || isNaN(price)) {
      return '0';
    }
    const n = Number(price);
    if (!isFinite(n)) {
      return '0';
    }
    return n
      .toFixed(18)
      .replace(/\.0+$/, '')
      .replace(/(\.\d*[1-9])0+$/, '$1');
  }

  render() {
    const {
      title,
      priceKat,
      priceUsdt,
      totalSession,
      totalDay,
      packageMainColor,
      packageSubColor,
      startDate,
      endDate,
      currentPackageExpiredDate,
    } = this.props;
    let classCardName = 'cardPackagePaymentSilver';
    switch (packageMainColor) {
      case '#bcefff':
        classCardName = 'cardPackagePaymentSilver';
        break;
      case '#ebeece':
        classCardName = 'cardPackagePaymentGold';
        break;
      case '#c1bcff':
        classCardName = 'cardPackagePaymentDiamond';
        break;
      default:
        classCardName = 'cardPackagePaymentSilver';
    }
    let classCardTopName = 'cardTopSilver';
    switch (packageMainColor) {
      case '#bcefff':
        classCardTopName = 'cardTopSilver';
        break;
      case '#ebeece':
        classCardTopName = 'cardTopGold';
        break;
      case '#c1bcff':
        classCardTopName = 'cardTopDiamond';
        break;
      default:
        classCardTopName = 'cardTopSilver';
    }
    // console.log('packageMainColor:', packageMainColor); // Log packageMainColor

    const formatDate = (date) => {
      if (date === undefined) return '';
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero indexed
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    };

    return (
      <Card className={classCardName}>
        <Box className={classCardTopName}>
          <Row className="d-flex justify-content-between">
            <Col className="col-left text-left">
              <br />
              <Typography variant="" className="payment-price-card-name">
                {this.props.title}
              </Typography>
            </Col>
            <Col className={'col-right text-right'}>
              <br />
              <Typography variant="" className="number-of-session">
                {this.props.totalSession} {I18n.t('session')}
              </Typography>
              <br />
              <Typography variant="" className="number-of-day">
                {I18n.t('expires_after_days', {day: this.props.totalDay})}
              </Typography>
            </Col>
          </Row>

          <Row className="d-flex justify-content-between">
            <Col className="col-left">
              <br />
              <Typography variant="" className="number-of-day">
                {I18n.t('priced_in', {money: "USDT"})}
              </Typography>
            </Col>
            <Col className="col-right">
              <br />
              <Typography variant="" className="price-Kat">
                {this.formatPrice(this.props.priceUsdt)} USDT
              </Typography>
            </Col>
          </Row>
          <Row className="d-flex justify-content-between">
            <Col className="col-left">
              <Typography variant="" className="number-of-day">
                {I18n.t('priced_in', {money: "KAT"})}
              </Typography>
            </Col>
            <Col className="col-right">
              <Typography variant="" className="price-Kat">
                {this.formatPrice(this.props.priceKat)} KAT
              </Typography>
            </Col>
          </Row>

          <hr style={{backgroundColor: '#EEEFF2', marginBottom: '0' }} />
          <Row>
            {currentPackageExpiredDate ? (
              <Tooltip title={I18n.t('package_cumulative_tooltip', { date: formatDate(currentPackageExpiredDate) })}>
                <Box component="span" sx={{ display: 'inline-block' }}>
                  <ul className="list-start-end">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.9974 1.66406C5.40573 1.66406 1.66406 5.40573 1.66406 9.9974C1.66406 14.5891 5.40573 18.3307 9.9974 18.3307C14.5891 18.3307 18.3307 14.5891 18.3307 9.9974C18.3307 5.40573 14.5891 1.66406 9.9974 1.66406ZM13.6224 12.9724C13.5057 13.1724 13.2974 13.2807 13.0807 13.2807C12.9724 13.2807 12.8641 13.2557 12.7641 13.1891L10.1807 11.6474C9.53906 11.2641 9.06406 10.4224 9.06406 9.68073V6.26406C9.06406 5.9224 9.3474 5.63906 9.68906 5.63906C10.0307 5.63906 10.3141 5.9224 10.3141 6.26406V9.68073C10.3141 9.98073 10.5641 10.4224 10.8224 10.5724L13.4057 12.1141C13.7057 12.2891 13.8057 12.6724 13.6224 12.9724Z" fill="#6B7280"/>
                    </svg>
                    <li></li>
                    <li>{formatDate(startDate)}</li>
                    <li>-</li>
                    <li>{formatDate(endDate)}</li>
                  </ul>
                </Box>
              </Tooltip>
            ) : (
              <ul className="list-start-end">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.9974 1.66406C5.40573 1.66406 1.66406 5.40573 1.66406 9.9974C1.66406 14.5891 5.40573 18.3307 9.9974 18.3307C14.5891 18.3307 18.3307 14.5891 18.3307 9.9974C18.3307 5.40573 14.5891 1.66406 9.9974 1.66406ZM13.6224 12.9724C13.5057 13.1724 13.2974 13.2807 13.0807 13.2807C12.9724 13.2807 12.8641 13.2557 12.7641 13.1891L10.1807 11.6474C9.53906 11.2641 9.06406 10.4224 9.06406 9.68073V6.26406C9.06406 5.9224 9.3474 5.63906 9.68906 5.63906C10.0307 5.63906 10.3141 5.9224 10.3141 6.26406V9.68073C10.3141 9.98073 10.5641 10.4224 10.8224 10.5724L13.4057 12.1141C13.7057 12.2891 13.8057 12.6724 13.6224 12.9724Z" fill="#6B7280"/>
                </svg>
                <li></li>
                <li>{formatDate(startDate)}</li>
                <li>-</li>
                <li>{formatDate(endDate)}</li>
              </ul>
            )}
          </Row>
        </Box>
        <div style={{ backgroundColor: '#EAFAFF' }}>{/* Insert content here */}</div>
      </Card>
    );
  }
}

export default withRouter(connect(null, {})(CardPackagePayment));
